import React from 'react';
import { Accordion } from '../ui/Accordion';
const faqItems = [{
  question: '¿Es realmente posible entrenar para un triatlón con solo 6 horas?',
  answer: "Sí, absolutamente. El secreto no está en el volumen, sino en la calidad de las sesiones. Este plan elimina el 'entrenamiento basura' y se enfoca en estímulos específicos que generan adaptaciones reales, ideal para distancias Short o Sprint."
}, {
  question: '¿Necesito experiencia previa en las tres disciplinas?',
  answer: 'No necesitas ser un experto, pero es recomendable saber nadar (al menos flotar y desplazarte) y saber andar en bicicleta. El plan está diseñado para llevarte progresivamente desde un nivel básico hasta cruzar la meta.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'El acceso es inmediato. Una vez confirmado el pago, recibirás un correo electrónico con los enlaces para descargar todos los PDFs y materiales adicionales. Podrás guardarlos en tu celular, tablet o imprimirlos.'
}, {
  question: '¿Qué pasa si me pierdo un entrenamiento?',
  answer: 'El plan es flexible. Incluye una guía sobre cómo reestructurar tu semana si surge un imprevisto (trabajo, familia, etc.) para que no pierdas el hilo ni te sobreentrenes intentando recuperar sesiones.'
}, {
  question: '¿Tienen garantía de devolución?',
  answer: 'Sí, tienes 7 días de garantía incondicional. Si descargas el material y sientes que no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
}];
export function FAQ() {
  return <section className="py-24 bg-brand-dark" data-id="element-3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
        <div className="text-center mb-16" data-id="element-5">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-6">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-white/70 max-w-2xl mx-auto" data-id="element-7">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <Accordion items={faqItems} data-id="element-8" />
      </div>
    </section>;
}